import React, { useState, useEffect, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import FallbackSpinner from './components/FallbackSpinner';
import NavBarWithRouter from './components/NavBar';
import Home from './components/Home';
import endpoints from './constants/endpoints';
import { Helmet } from 'react-helmet';

function MainApp() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(endpoints.routes, {
      method: 'GET',
    })
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((err) => err);
  }, []);

  return (
    <div className="MainApp">
           <Helmet>
          <title>Charbel Daoud</title>
          <meta name="author" content="Charbel daoud"></meta>
          <meta http-equiv="X-UA-Compatible" content="IE=edge" />
       <meta name="description" content="Charbel Daoud: Full stack developer specializing in modern web app development. Proven track record of delivering quality solutions. Contact me for your next project."></meta>
          <link
            rel="canonical"
            href="https://www.charbeldaoud.com"
          />
              <link rel="apple-touch-icon" href="../favicon.ico"></link>
    <link rel="icon" type="image/x-icon" href="../favicon.ico"></link>
        </Helmet>
      <NavBarWithRouter />
      <main className="main">
        <Switch>
          <Suspense fallback={<FallbackSpinner />}>
            <Route exact path="/" component={Home} />
            {data
              && data.sections.map((route) => {
                const SectionComponent = React.lazy(() => import('./components/' + route.component));
                return (
                  <Route
                    key={route.headerTitle}
                    path={route.path}
                    component={() => (
                      <SectionComponent header={route.headerTitle} />
                    )}
                  />
                );
              })}
          </Suspense>
        </Switch>
      </main>
    </div>
  );
}

export default MainApp;
